import { v3 } from '@adobe/edex/frontend/api/v3';
import { AxiosRequestConfig } from 'axios';

const baseURL = `/members`;
const selfURL = `/self`;

export function fetchLeaders() {
  return v3.get(`${baseURL}/leaders`);
}

export function self() {
  return v3.get(`${selfURL}`);
}

export function fetchStats() {
  return v3.get(`${selfURL}/stats`);
}

export function inviteSelf(data) {
  return v3.post(`${selfURL}/invitations`, data);
}

export function updateSelf(data) {
  return v3.put(`${selfURL}`, data);
}

export function updateSelfExperience(data) {
  return v3.put(`${selfURL}/experience`, data);
}

export function updateSelfExpertise(data) {
  return v3.put(`${selfURL}/expertise`, data);
}

export function updateSelfInterests(data) {
  return v3.put(`${selfURL}/interests`, data);
}

export function updateSelfSettings(data) {
  return v3.put(`${selfURL}/settings`, data);
}

export function fetchRecentlyViewed() {
  return v3.get(`${selfURL}/recent`);
}

export function deactivateSelf() {
  return v3.delete(`${selfURL}`);
}

export function fetchMember(id) {
  return v3.get(`${baseURL}/${id}`);
}

export function follow(id) {
  return v3.post(`${selfURL}/follow/${id}`);
}

export function unfollow(id) {
  return v3.delete(`${selfURL}/follow/${id}`);
}

export function listFollowers(id, config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/${id}/followers`, config);
}

export function listFollowing(id, config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/${id}/following`, config);
}

export function updateSchoolEmail(email) {
  return v3.put(`${selfURL}/school-email`, { schoolEmail: email });
}

export function removeSchoolEmail() {
  return v3.delete(`${selfURL}/school-email`);
}

export function verifySchoolEmail(data) {
  return v3.post(`${selfURL}/verify-school-email`, { otp: data });
}

export function resendVerificationEmail() {
  return v3.post(`${selfURL}/resend-verification-email`);
}
